export enum EstadoFactura {
  PENDIENTE = 'Pendiente',
  PAGADA = 'Pagada',
  RECHAZADO = 'Rechazado',
  ENVIADO = 'Enviado',
  APROBADO = 'Aprobado',
  // Valor real persistido en factura_cab.estado (masculino, consistente con el
  // resto del ERP que usa "Cancelado", "Aprobado", etc.).
  ANULADA = 'Anulado',
}

export enum EstadoSifen {
  PENDIENTE = 'Pendiente',
  APROBADO = 'Aprobado',
  RECHAZADO = 'Rechazado',
  CANCELADO = 'Cancelado',
}
